export default {
    conversationTrail: {},
    prompt: {
        type: 'agent',
        product: "",
        intent: "buy",
        demographics: ""
    }
}
